import * as api from "../../api";
import { buildAlertWithLocalizedMessages } from "../";
import { jsError } from "../../common/utils";
/* export * from "./authentication"; */

export const postContractComplete = contractId => {
  return dispatch => {
    dispatch({ type: "POST_CONTRACT_COMPLETE_LOADING" });
    api
      .contractCompletePost(contractId)
      .then(resp => {
        dispatch(operationSucceeded(resp.data));
      })
      .catch(e => {
        jsError(e);
        dispatch(operationFailed());
        dispatch(buildAlertWithLocalizedMessages(
          "ERROR",
          "PostContractCompleteErrorAlertTitle",
          "Virhe työsopimuksen voimaan asettamisessa",
          e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
      });
  };
};

const operationSucceeded = data => ({
  type: "POST_CONTRACT_COMPLETE_SUCCEEDED",
  payload: { contract: data },
});

const operationFailed = () => ({
  type: "POST_CONTRACT_COMPLETE_FAIL",
});
